export default "<a class=\"google-play\" target=\"_blank\" data-bind=\"attr: { href: playStoreURL }, visible: playStoreURL\">\n  <div></div>\n</a>\n";